import React from 'react';

const PersonalInformationSection = ({ 
  formData, 
  emailError, 
  isSubmitting, 
  handleChange 
}) => {
  return (
    <>
      <div className="col-span-full">
        <h3 className="text-black font-semibold mb-4 font-poppins text-lg">
          Personal Information
        </h3>
      </div>

      <div className="col-span-full">
        <label className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
          Personal Email <span className="text-red-500">*</span>
        </label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
          disabled={isSubmitting}
          className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-poppins ${
            emailError ? 'border-red-300' : 'border-gray-300'
          }`}
          placeholder="Enter your email"
        />
        {emailError && (
          <p className="mt-1 text-sm text-red-600 font-poppins">{emailError}</p>
        )}
      </div>
    </>
  );
};

export default PersonalInformationSection; 